import React from "react";
import { Link } from "react-router-dom";
import { SquarePen } from "lucide-react";

const EditButton = React.memo((props) => {
  return (
    <Link
      to="/edit-meeting"
      state={{
        meetingId: props?.meetingData?.singleMeetingDetails?._id,
        isMeetingDataUpdate: true,
        step: props?.meetingData,
      }}
      style={{
        textDecoration: "none",
        color: "black",
      }}
    >
      <button className="plus-icon">
        <SquarePen size={22} />
      </button>
    </Link>
  );
});

export default EditButton;
